import React from "react";
import PopularSectors from "./PopularSectors";
import BrandInsightsTabs from "./BrandInsightsTabs ";
import "./Styling.css";

const BrandStatsCard = ({ insights }) => {
 
  return (
    <div className="brand-stats-card">
      <PopularSectors data={insights.brandData?.most_asked_domains} totalUsers={12540} />
      <BrandInsightsTabs barData={insights.brandData?.most_asked_brands} missingData={insights.brandData?.brands_not_present} />
    </div>
    
  );
};

export default BrandStatsCard;
